
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Soft_tissue_sarcoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Soft_tissue_sarcoma.vue